import type { Comment } from '~/gql/graphql'

/**
 *
 */
export default function getNextUnprocessedComment(
  comments: Comment[],
  current: Comment | null = null,
  goForward = true,
): Comment | null {
  if (!comments) return null

  const unprocessed = getUnprocessedComments(comments, goForward)

  const currIndex = current
    ? unprocessed.findIndex((el: Comment) => el.id === current.id)
    : -1

  const comment = unprocessed[currIndex + 1]

  return comment || current
}

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'comments' implicitly has an 'any' type.
function getUnprocessedComments(comments, goForward) {
  // @ts-expect-error TS(7006) FIXME: Parameter 'acc' implicitly has an 'any' type.
  const result = comments.reduce((acc, comment) => {
    const { replies, needsAttention, error } = comment

    const toAcc = needsAttention && !error ? comment : []

    const unprocessedReplies = replies
      ? getUnprocessedComments(replies, goForward)
      : []

    return goForward
      ? acc.concat(toAcc).concat(unprocessedReplies)
      : [].concat(unprocessedReplies).concat(toAcc).concat(acc)
  }, [])

  return result
}
